import {
    UserStore,
    PagePathStore,
    ReferrerStore,
} from '../../../shared/mixpanel';

export default {
    user: new UserStore(),
    pagePath: new PagePathStore(),
    referrer: new ReferrerStore(),
};
